import type { AircraftView } from '@fsv/core';
import { resolveDrawing, type ResolvedDrawing } from '@fsv/data';
import { useAircraftTypes } from '../data/hooks';

export { resolveDrawing, type ResolvedDrawing };

/** The drawing for an aircraft type and view, or null while the types load. */
export function useDrawing(typeCode: string | undefined, view: AircraftView): ResolvedDrawing | null {
  const types = useAircraftTypes();
  const type = types.data?.find((t) => t.code === typeCode);
  return type ? resolveDrawing(type, view) : null;
}
